import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function AGB() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
      <Link to="/" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-slate-800 transition-colors mb-8">
        <ArrowLeft className="h-4 w-4" /> Zurück zur Startseite
      </Link>

      <h1 className="text-3xl font-outfit font-extrabold text-slate-900 mb-2">Nutzungsbedingungen & Community-Regeln</h1>
      <p className="text-slate-400 text-sm mb-10">Stand: Juni 2026</p>

      <div className="space-y-8 text-slate-700 text-sm leading-relaxed">

        <div className="bg-gradient-to-r from-[#A259FF]/10 to-[#FF62A5]/10 border border-[#A259FF]/20 rounded-xl p-4 text-slate-700 text-sm">
          dealzauber.de ist eine kostenlose Community-Plattform für Schnäppchen. Wir freuen uns über jeden,
          der mitmacht — bitte halte Dich dabei an diese Regeln, damit alle eine gute Zeit haben.
        </div>

        <section>
          <h2 className="font-outfit font-bold text-base text-slate-900 mb-3">§ 1 Geltungsbereich</h2>
          <p>
            Diese Nutzungsbedingungen gelten für die Nutzung der Plattform dealzauber.de, betrieben von
            Kenan Artiran & Mustafa Emirler, Parksiedlung Spruch 86, 12349 Berlin.
            Mit der Nutzung der Plattform stimmst Du diesen Bedingungen zu.
          </p>
        </section>

        <section>
          <h2 className="font-outfit font-bold text-base text-slate-900 mb-3">§ 2 Leistungsbeschreibung</h2>
          <p>
            dealzauber.de ist eine Deal-Community-Plattform, auf der Nutzer Angebote entdecken, bewerten,
            kommentieren und selbst einreichen können. Die Plattform vermittelt ausschließlich zu externen Shops
            und führt <strong>keine eigenen Verkäufe</strong> durch. Verlinkungen können Affiliate-Links sein.
          </p>
          <p className="mt-2">
            Die Grundfunktionen (Deals anzeigen, Suchen, Abstimmen) sind ohne Registrierung nutzbar.
            Kommentieren und Deals einreichen erfordert ein kostenloses Konto.
          </p>
        </section>

        <section>
          <h2 className="font-outfit font-bold text-base text-slate-900 mb-3">§ 3 Registrierung</h2>
          <ul className="list-disc ml-5 space-y-1">
            <li>Die Registrierung ist kostenlos und ab 16 Jahren möglich</li>
            <li>Pro Person ist nur ein Konto erlaubt</li>
            <li>Es sind wahrheitsgemäße Angaben zu machen</li>
            <li>Zugangsdaten sind vertraulich zu behandeln und dürfen nicht weitergegeben werden</li>
            <li>Der Betreiber kann Konten bei Regelverstößen sperren oder löschen</li>
          </ul>
        </section>

        <section>
          <h2 className="font-outfit font-bold text-base text-slate-900 mb-3">§ 4 Regeln für Deal-Einreichungen</h2>
          <p className="mb-3">Ein guter Deal auf dealzauber.de sollte folgende Kriterien erfüllen:</p>
          <ul className="list-disc ml-5 space-y-2">
            <li><strong>Echt und aktuell:</strong> Das Angebot muss zum Zeitpunkt der Einreichung verfügbar sein</li>
            <li><strong>Preisangabe:</strong> Original- und Angebotspreis sind korrekt anzugeben</li>
            <li><strong>Keine Duplikate:</strong> Bereits vorhandene Deals sollen nicht erneut eingestellt werden</li>
            <li><strong>Eigener Content:</strong> Texte und Bilder anderer Plattformen (mydealz, Amazon etc.) dürfen nicht 1:1 kopiert werden</li>
            <li><strong>Kein Spam:</strong> Eigenwerbung oder kommerzielle Werbung ohne Genehmigung ist nicht erlaubt</li>
            <li><strong>Kein Affiliate-Link-Missbrauch:</strong> Eigene Affiliate-Tags in Links einzubauen ist nicht erlaubt</li>
            <li><strong>Mindestrabatt:</strong> Angebote sollten einen echten Mehrwert bieten (empfohlen: mind. 10 % Rabatt)</li>
          </ul>
          <p className="mt-3 text-slate-500">
            Eingereichte Deals werden vom Team geprüft. Wir behalten uns vor, Deals ohne Angabe von Gründen abzulehnen oder zu entfernen.
          </p>
        </section>

        <section>
          <h2 className="font-outfit font-bold text-base text-slate-900 mb-3">§ 5 Community-Verhalten</h2>
          <p className="mb-3">Im Umgang miteinander und beim Verfassen von Kommentaren gilt:</p>
          <ul className="list-disc ml-5 space-y-2">
            <li>Respektvoller Umgang — keine Beleidigungen, Hassrede oder Diskriminierung</li>
            <li>Keine politischen oder religiösen Diskussionen, die nicht zum Thema gehören</li>
            <li>Keine persönlichen Angriffe auf andere Nutzer oder Händler</li>
            <li>Das Abstimmungssystem (Temperatur) darf nicht durch Mehrfachaccounts manipuliert werden</li>
            <li>Keine Verbreitung von Fehlinformationen über Produkte oder Händler</li>
          </ul>
        </section>

        <section>
          <h2 className="font-outfit font-bold text-base text-slate-900 mb-3">§ 6 Preisangaben & Haftungsausschluss</h2>
          <p>
            Die auf der Plattform angezeigten Preise und Rabatte stammen aus öffentlich verfügbaren Quellen und
            können sich jederzeit ändern. <strong>Maßgeblich ist stets der Preis beim jeweiligen Händler</strong> zum
            Zeitpunkt des Kaufs. Wir übernehmen keine Garantie für die Richtigkeit oder Verfügbarkeit der Angebote.
          </p>
        </section>

        <section>
          <h2 className="font-outfit font-bold text-base text-slate-900 mb-3">§ 7 Urheberrecht an Nutzerinhalten</h2>
          <p>
            Durch das Einreichen von Inhalten (Deals, Kommentare) gewährst Du dealzauber.de ein nicht-exklusives,
            weltweites Nutzungsrecht zur Darstellung auf der Plattform. Du bleibst Urheber Deiner Inhalte.
            Du versicherst, dass Du über alle notwendigen Rechte an den eingestellten Inhalten verfügst.
          </p>
        </section>

        <section>
          <h2 className="font-outfit font-bold text-base text-slate-900 mb-3">§ 8 Sperrung & Kündigung</h2>
          <p>
            Du kannst Dein Konto jederzeit durch eine E-Mail an{" "}
            <a href="mailto:admin@dealzauber.de" className="text-[#A259FF] hover:underline">admin@dealzauber.de</a>{" "}
            löschen lassen. Bei schwerwiegenden oder wiederholten Verstößen gegen diese Bedingungen können
            wir Konten ohne Vorankündigung sperren oder dauerhaft löschen.
          </p>
        </section>

        <section>
          <h2 className="font-outfit font-bold text-base text-slate-900 mb-3">§ 9 Änderungen</h2>
          <p>
            Wir behalten uns vor, diese Bedingungen jederzeit anzupassen. Über wesentliche Änderungen werden
            registrierte Nutzer per E-Mail informiert. Die weitere Nutzung der Plattform gilt als Zustimmung.
          </p>
        </section>

        <section>
          <h2 className="font-outfit font-bold text-base text-slate-900 mb-3">§ 10 Anwendbares Recht & Gerichtsstand</h2>
          <p>
            Es gilt das Recht der Bundesrepublik Deutschland. Erfüllungsort und Gerichtsstand ist Berlin,
            soweit gesetzlich zulässig.
          </p>
        </section>

      </div>
    </div>
  );
}
